import Vue from 'vue';
//import Vuetify from 'vuetify/lib/framework';


import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';
import es from 'vuetify/lib/locale/es';
//import es from 'vuetify/es5/locale/es';

import moment from 'moment';
import 'moment/locale/es';  // Importa el archivo de idioma de moment
import brand from '../config/brand';

moment.locale('es');

Vue.use(Vuetify);

//export default new Vuetify({
//});

export default new Vuetify({
    lang: {
      locales: { es },
      current: 'es',
    },
    theme: {
      themes: {
        light: {
          primary: brand.theme.primary,
          secondary: brand.theme.secondary,
          accent: brand.theme.accent,
        },
      },
    },
  });

